module.exports = __webpack_public_path__ + "static/media/RatingBanner.115a412d.svg";